import { Sponsor } from 'services/openapi';
import { defaultLookup } from '../RiderIndividual/components/RiderCreatePage/staticDatas';

export const breadCrumpitems = [
  {
    id: '',
    text: 'Showyeda admin',
    disabled: true,
  },
  {
    id: '/admin/sponsors',
    text: 'Sponsors',
  },
];
export const createBreadCrumpitems = [
  {
    id: '',
    text: 'Showyeda admin',
    disabled: true,
  },
  {
    id: '/admin/sponsors',
    text: 'Sponsors',
  },
  {
    id: '',
    text: 'Create Sponsor',
    disabled: true,
  },
];

export const sponsorDefaultValue: Sponsor = {
  id: null,
  name: '',
  divisionClass: defaultLookup,
  split: null,
};
